import { FormattedMessage } from "react-intl";
import StandardButton from "../../elements/buttons/standard.button";
import React from "react";

export default function DoorSignScannerInfo(props) {
  return (
    <StandardButton
      buttonClasses="ml-3 mr-auto pointer-event-on"
      handleClick={props.onClick}
    >
      <div className="d-flex">
        <div className="scan-door-button-icon-container ">
          <svg
            width="51px"
            height="35px"
            viewBox="0 0 51 35"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Doorscan</title>
            <g
              id="2.0"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="iPhone-14-Pro-Copy-26"
                transform="translate(-23, -673)"
                fill="#000000"
                fill-rule="nonzero"
              >
                <g id="Group-4" transform="translate(9.37, 651.23)">
                  <g id="Group-2" transform="translate(5.63, 5.77)">
                    <g id="Doorscan" transform="translate(8.9808, 15.9993)">
                      <path
                        d="M36.5031626,13.4945537 C35.4384717,13.4945537 34.5753692,14.3576562 34.5753692,15.422347 C34.5753692,16.4870379 35.4384717,17.3501404 36.5031626,17.3501404 C37.5678535,17.3501404 38.430956,16.4870379 38.430956,15.422347 C38.430956,14.3576562 37.5678535,13.4945537 36.5031626,13.4945537 Z"
                        id="Shape"
                      ></path>
                      <path
                        d="M11.9944894,8.01239124 C10.5426201,8.01239124 9.25340823,8.9401418 8.7955573,10.3197189 L10.1691101,10.7775699 L8.7955573,10.3197189 L8.27746283,11.867978 L3.85558676,11.867978 C1.72898969,11.867978 0,13.5969677 0,15.7235648 L0,31.1459118 C0,33.2725089 1.72898969,35.0014986 3.85558676,35.0014986 L26.9891073,35.0014986 C29.1157044,35.0014986 30.8446941,33.2725089 30.8446941,31.1459118 L30.8446941,15.7235648 C30.8446941,13.5969677 29.1157044,11.867978 26.9891073,11.867978 L22.5672313,11.867978 L22.0491368,10.3197189 C21.5912859,8.9401418 20.302074,8.01239124 18.8502047,8.01239124 L11.9944894,8.01239124 Z M11.5366385,11.2354208 C11.6029064,11.0366171 11.783637,10.9040813 11.9944894,10.9040813 L18.8502047,10.9040813 C19.0550327,10.9040813 19.2417877,11.0366171 19.3080556,11.2354208 L20.1514652,13.771674 C20.3502689,14.3620607 20.8984851,14.7596681 21.525018,14.7596681 L26.9891073,14.7596681 C27.5192505,14.7596681 27.953004,15.1934216 27.953004,15.7235648 L27.953004,31.1459118 C27.953004,31.676055 27.5192505,32.1098085 26.9891073,32.1098085 L3.85558676,32.1098085 C3.32544358,32.1098085 2.89169007,31.676055 2.89169007,31.1459118 L2.89169007,15.7235648 C2.89169007,15.1934216 3.32544358,14.7596681 3.85558676,14.7596681 L9.31967613,14.7596681 C9.94018462,14.7596681 10.4944252,14.3620607 10.6932289,13.771674 L11.5366385,11.2354208 Z M15.422347,30.1820151 C17.8329169,30.1820151 20.0603753,28.8959915 21.2656603,26.8083767 C22.4709452,24.720762 22.4709452,22.1487146 21.2656603,20.0610998 C20.0603753,17.9734851 17.8329169,16.6874615 15.422347,16.6874615 C11.6959289,16.6874615 8.67507021,19.7083202 8.67507021,23.4347383 C8.67507021,27.1611564 11.6959289,30.1820151 15.422347,30.1820151 Z M11.5667603,23.4347383 C11.5667603,21.3053565 13.2929653,19.5791515 15.422347,19.5791515 C17.5517288,19.5791515 19.2779338,21.3053565 19.2779338,23.4347383 C19.2779338,25.5641201 17.5517288,27.290325 15.422347,27.290325 C13.2929653,27.290325 11.5667603,25.5641201 11.5667603,23.4347383 Z"
                        id="Shape"
                      ></path>
                      <path
                        d="M23.0086089,10.1335223 L22.5753365,8.33644589 C22.3896886,7.56643709 21.7671115,6.97853706 20.9877376,6.83727492 L20.1169188,6.67943834 L20.1169188,6.67943834 L20.1169188,2 C20.1169188,0.8954305 21.0123493,1.3527075e-16 22.1169188,0 L41.2337723,3.99680289e-15 C42.3383418,3.79389676e-15 43.2337723,0.8954305 43.2337723,2 L43.2337723,27.9280948 L43.2337723,27.9280948 L48.0383878,27.9280948 C48.5906725,27.9280948 49.0383878,28.37581 49.0383878,28.9280948 L49.0383878,29.8446941 C49.0383878,30.3969788 48.5906725,30.8446941 48.0383878,30.8446941 L32.4238162,30.8446941 L32.4238162,30.8446941 L32.4238162,27.9280948 L40.3794376,27.9280948 L40.3794376,3.48188791 C40.3794376,3.20574554 40.1555799,2.98188791 39.8794376,2.98188791 L23.5086089,2.98188791 C23.2324665,2.98188791 23.0086089,3.20574554 23.0086089,3.48188791 L23.0086089,10.1335223 L23.0086089,10.1335223 Z"
                        id="Path-2"
                      ></path>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </svg>
        </div>
        <div className="scan-door-button-text-container">
          <h2>
            <FormattedMessage id={"scanner.button.title"} />
          </h2>
          <span>
            <FormattedMessage id={"scanner.button.text"} />
          </span>
        </div>
      </div>
    </StandardButton>
  );
}
